import React, { useMemo } from "react";
import DOMPurify from "dompurify";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { getImageUrlWithExpiry } from "@src/utils/ImageExpirtyHelper";
import type { INewsSlider } from "@src/types/AppTypes";

const NewsSlider: React.FC<INewsSlider> = ({
  newsList,
  returnBgImages,
  inHouseList,
  showNews,
}) => {
  const getNewsArr = useMemo(() => {
    if (showNews) return newsList;
    else return inHouseList;
  }, [showNews, newsList, inHouseList]);

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 1450 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 1450, min: 1140 },
      items: 4,
    },
    tablet: {
      breakpoint: { max: 1140, min: 767 },
      items: 3,
    },
    smtablet: {
      breakpoint: { max: 767, min: 512 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 512, min: 0 },
      items: 1,
    },
  };

  return (
    <div className="custom-news-slider">
      <div className="relative">
        <Carousel
          renderArrowsWhenDisabled
          responsive={responsive}
          className="pt-5 px-5 max-sm:p-0"
        >
          {getNewsArr.map((news, newsIndex) => {
            return (
              <div
                key={news.id}
                role="button"
                className={returnBgImages(newsIndex)}
                onClick={() => {
                  const url =
                    `/${news.news_type.toLowerCase().replace(/ /g, "-")}/` +
                    news.slug;
                  window.open(url, "_blank", "noopener");
                }}
              >
                <div>
                  <div className="h-[397px] relative border-2 border-black w-full">
                    <img
                      className="size-full object-contain relative z-10"
                      src={getImageUrlWithExpiry(news.thumbnail)}
                      alt=""
                    />
                    <img
                      className="size-full object-cover absolute blur-sm top-0 bg-blue"
                      src={getImageUrlWithExpiry(news.thumbnail)}
                      alt=""
                    />
                  </div>
                  <h2 className="text-lg text-white my-2 truncate">
                    {news.title}
                  </h2>
                  <p
                    className="text-xl font-mikado-regular uppercase text-white line-clamp-2 break-words"
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(news.description),
                    }}
                  ></p>
                </div>
              </div>
            );
          })}
        </Carousel>
      </div>
    </div>
  );
};

export default NewsSlider;
